import { useState, useEffect } from 'react';
import './dualrangeslider.scss'

type Props = {
  min: number;
  max: number;
  step?: number;
  onChange?: (minVal: number, maxVal: number) => void;
};

const DualRangeSlider = ({ min, max, step = 1, onChange }: Props) => {
  const [minVal, setMinVal] = useState(min);
  const [maxVal, setMaxVal] = useState(max);

  // Sync internal state with prop changes
  useEffect(() => {
    setMinVal(min);
    setMaxVal(max);
  }, [min, max, step]);

  // Keep min <= max and trigger onChange
  useEffect(() => {
    if (minVal > maxVal) setMinVal(maxVal);
    if (maxVal < minVal) setMaxVal(minVal);
    onChange?.(minVal, maxVal);
    // eslint-disable-next-line
  }, [minVal, maxVal]);

  return (
    <div className="dual-slider">
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={minVal}
        onChange={(e) => setMinVal(Number(e.target.value))}
        className="thumb thumb--left"
        style={{ zIndex: minVal > max - 100 ? 5 : 4 }}
      />
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={maxVal}
        onChange={(e) => setMaxVal(Number(e.target.value))}
        className="thumb thumb--right"
        style={{zIndex:3}}
      />

      <div className="slider-track" />
      <div
        className="slider-range"
        style={{
          left: `${((minVal - min) / (max - min)) * 100}%`,
          width: `${((maxVal - minVal) / (max - min)) * 100}%`,
        }}
      />
    </div>
  );
};

export default DualRangeSlider;
